// extracted by mini-css-extract-plugin
module.exports = {"Hamburger":"style_Hamburger__3b_ca","Hamburger_dark":"style_Hamburger_dark__1-4AQ","Hamburger_light":"style_Hamburger_light__2OzW0"};